import React from "react";
import { ModalButtonsContainer, TextButton } from "@SeemplicityDev/shared";
import { NODE_TYPE_LABELS, type NameCollision } from "./types";
import "./DeleteScopeGroupCollision.scss";

export interface DeleteScopeGroupCollisionProps {
  groupName?: string;
  collisions: NameCollision[];
  onCancel: () => void;
}

const NODE_TYPE_ICONS: Record<NameCollision["node_type"], string> = {
  group: "seem-icon-scope-group",
  scope: "seem-icon-scope",
};

const DeleteScopeGroupCollision: React.FC<DeleteScopeGroupCollisionProps> = ({
  groupName,
  collisions,
  onCancel,
}) => (
  <div className={"modal-text delete-scope-group-collision"}>
    <div className={"delete-scope-group-collision-message"}>
      {
        "One or more scopes with the same name as this group's children already exist in the root group. To delete the "
      }
      <span className={"modal-live-text"}>{groupName}</span> group, please
      rename those scopes.
    </div>

    <ul className={"delete-scope-group-collision-list"}>
      {collisions.map((collision) => (
        <li
          key={`${collision.node_type}:${collision.name}`}
          className={"delete-scope-group-collision-row"}
          data-testid={"scope-group-collision-row"}
        >
          <span className={"delete-scope-group-collision-row-node"}>
            <i
              className={`seem-icon ${NODE_TYPE_ICONS[collision.node_type]} delete-scope-group-collision-row-icon`}
              aria-label={NODE_TYPE_LABELS[collision.node_type]}
              title={NODE_TYPE_LABELS[collision.node_type]}
            />
            <span>{collision.name}</span>
          </span>
          <i
            className={
              "seem-icon seem-icon-warning delete-scope-group-collision-row-warning"
            }
            aria-label={"Name already exists"}
            title={"Name already exists"}
          />
        </li>
      ))}
    </ul>

    <ModalButtonsContainer centerButtons>
      <TextButton
        buttonStyle={"secondary"}
        label={"Cancel"}
        onClick={onCancel}
        data-testid={"cancel-delete-scope-group"}
      />
      <TextButton
        buttonStyle={"danger"}
        label={"Delete"}
        disabled
        data-testid={"confirm-delete-scope-group-collision"}
      />
    </ModalButtonsContainer>
  </div>
);

export default DeleteScopeGroupCollision;
